// src/constants/variables-data.ts
var variablesData = {
  "@collection_1": {
    $collection_metadata: {
      name: "Collection 1",
      figmaId: "VariableCollectionId:2:46",
      modes: [
        {
          key: "mode_1",
          name: "Mode 1"
        }
      ]
    },
    primary_color: {
      $type: "color",
      $value: "#ff0000",
      $description: "",
      $variable_metadata: {
        name: "primary_color",
        figmaIds: [
          "VariableID:2:47",
          "VariableID:2:36"
          // Brand and Variables collection
        ],
        modes: {
          mode_1: "rgba(255,0,0,1.00)"
        }
      }
    },
    secondary_color: {
      $type: "color",
      $value: "#150531",
      $description: "",
      $variable_metadata: {
        name: "secondary_color",
        figmaIds: [
          "VariableID:2:48",
          "VariableID:6:55"
          // Brand and Variables collection
        ],
        modes: {
          mode_1: "rgba(21,5,49,1.00)"
        }
      }
    },
    primary_font: {
      $type: "unknown",
      $value: "Source Sans Pro",
      $description: "",
      $variable_metadata: {
        name: "primary_font",
        figmaIds: [
          "VariableID:2:49",
          "VariableID:6:56"
          // Brand and Variables collection
        ],
        modes: {
          mode_1: "Source Sans Pro"
        }
      }
    },
    primary_font_weight: {
      $type: "unknown",
      $value: "Bold",
      $description: "",
      $variable_metadata: {
        name: "primary_font_weight",
        figmaIds: ["VariableID:32:582"],
        modes: {
          mode_1: "Bold"
        }
      }
    },
    secondary_font: {
      $type: "unknown",
      $value: "Roboto Condensed",
      $description: "",
      $variable_metadata: {
        name: "secondary_font",
        figmaIds: [
          "VariableID:2:50",
          "VariableID:6:57"
          // Brand and Variables collection
        ],
        modes: {
          mode_1: "Roboto Condensed"
        }
      }
    },
    secoundary_font_weight: {
      $type: "unknown",
      $value: "Regular",
      $description: "",
      $variable_metadata: {
        name: "secoundary_font_weight",
        figmaIds: ["VariableID:32:583"],
        modes: {
          mode_1: "Regular"
        }
      }
    },
    background_text_color: {
      $type: "color",
      $value: "#ffffff",
      $description: "",
      $variable_metadata: {
        name: "background_text_color",
        figmaIds: [
          "VariableID:124:232",
          "VariableID:6:58"
          // New Figma file - white text color
        ],
        modes: {
          mode_1: "rgba(255,255,255,1.00)"
        }
      }
    },
    border_radius: {
      $type: "unknown",
      $value: "3",
      $description: "",
      $variable_metadata: {
        name: "border_radius",
        figmaIds: ["VariableID:30:577"],
        modes: {
          mode_1: "3"
        }
      }
    }
  }
};

// src/variable-resolver.ts
var VariableResolver = class {
  variableMap;
  config;
  constructor(config) {
    this.config = config;
    this.variableMap = /* @__PURE__ */ new Map();
    this.loadVariables();
  }
  loadVariables() {
    for (const collectionKey of Object.keys(variablesData)) {
      const collection = variablesData[collectionKey];
      for (const variableKey of Object.keys(collection)) {
        if (variableKey === "$collection_metadata")
          continue;
        const variable = collection[variableKey];
        const metadata = variable == null ? void 0 : variable.$variable_metadata;
        if ((metadata == null ? void 0 : metadata.name) && metadata.figmaIds) {
          for (const id of metadata.figmaIds) {
            this.variableMap.set(id, metadata.name);
          }
        }
      }
    }
  }
  /**
   * Get the variable name for a fill (color) binding.
   * Checks fills[0].boundVariables.color for the variable ID.
   * Returns null if fills config is false or no binding found.
   */
  resolveFillVariable(fills) {
    var _a, _b;
    if (!this.config.fills)
      return null;
    const colorBinding = (_b = (_a = fills == null ? void 0 : fills[0]) == null ? void 0 : _a.boundVariables) == null ? void 0 : _b.color;
    if (!colorBinding)
      return null;
    return this.variableMap.get(colorBinding.id) ?? null;
  }
  /**
   * Get the variable name for font family binding.
   * Returns null if fontFamily config is false or no binding found.
   */
  resolveFontFamilyVariable(boundVariables) {
    var _a;
    if (!this.config.fontFamily)
      return null;
    if (!((_a = boundVariables == null ? void 0 : boundVariables.fontFamily) == null ? void 0 : _a[0]))
      return null;
    return this.variableMap.get(boundVariables.fontFamily[0].id) ?? null;
  }
  /**
   * Get the variable name for font style/weight binding.
   * Returns null if fontStyle config is false or no binding found.
   */
  resolveFontStyleVariable(boundVariables) {
    var _a;
    if (!this.config.fontStyle)
      return null;
    if (!((_a = boundVariables == null ? void 0 : boundVariables.fontStyle) == null ? void 0 : _a[0]))
      return null;
    return this.variableMap.get(boundVariables.fontStyle[0].id) ?? null;
  }
};

// src/resolve-element-variables.ts
import {
  isImageElement,
  isSVGElement,
  isTextElement,
  isVectorElement
} from "@adflow/types";

// src/constants/brand-variables.ts
import { BrandVariable } from "@adflow/types";
var VARIABLES = {
  [BrandVariable.PRIMARY_COLOR]: "#00ff00",
  [BrandVariable.SECONDARY_COLOR]: "#150531",
  background_text_color: "#FFFFFF",
  [BrandVariable.PRIMARY_FONT]: "Arial",
  [BrandVariable.SECONDARY_FONT]: "Roboto Condensed",
  [BrandVariable.LOGO]: "https://placehold.co/143x43.png",
  [BrandVariable.BRAND_LOGO]: "https://placehold.co/338x86.png"
};

// src/brand-logo-variables.ts
import { BrandVariable as BrandVariable2 } from "@adflow/types";
var BRAND_LOGO_POSSIBLE_VALUES = [
  BrandVariable2.LOGO,
  BrandVariable2.BRAND_LOGO,
  `{{${BrandVariable2.LOGO}}}`,
  `{{${BrandVariable2.BRAND_LOGO}}}`,
  `{{var:${BrandVariable2.LOGO}}}`,
  `{{var:${BrandVariable2.BRAND_LOGO}}}`
];
function isBrandLogoVariable(content) {
  return BRAND_LOGO_POSSIBLE_VALUES.includes(content);
}

// src/resolve-element-variables.ts
function resolveValue(value, variables) {
  if (variables[value])
    return variables[value];
  const match = value.match(/\{\{(?:var:)?(\w+)\}\}/);
  if (match) {
    const varName = match[1];
    return variables[varName] ?? value;
  }
  return value;
}
function resolveSvgVariables(svg, variables = VARIABLES) {
  return svg.replace(/\{\{(?:var:)?(\w+)\}\}/g, (match, varName) => {
    return variables[varName] ?? match;
  });
}
function resolveElementVariables(elements, variables = VARIABLES) {
  return elements.map((element) => {
    var _a, _b;
    if (isTextElement(element)) {
      const style = element.data.style;
      return {
        ...element,
        data: {
          ...element.data,
          style: {
            ...style,
            color: style.color ? resolveValue(style.color, variables) : style.color,
            fontFamily: style.fontFamily ? resolveValue(style.fontFamily, variables) : style.fontFamily
          }
        }
      };
    }
    if (isVectorElement(element)) {
      const color = element.data.color;
      let content = element.data.content;
      if (content) {
        content = resolveSvgVariables(content, variables);
        if (((_a = color == null ? void 0 : color.fill) == null ? void 0 : _a.value) && variables[color.fill.value]) {
          content = content.replace(/\s+fill="[^"]*"/g, "");
        }
        if (((_b = color == null ? void 0 : color.stroke) == null ? void 0 : _b.value) && variables[color.stroke.value]) {
          content = content.replace(/\s+stroke="[^"]*"/g, "");
        }
      }
      return {
        ...element,
        data: {
          ...element.data,
          content,
          color: {
            ...color,
            fill: (color == null ? void 0 : color.fill) ? { ...color.fill, value: resolveValue(color.fill.value, variables) } : null,
            stroke: (color == null ? void 0 : color.stroke) ? { ...color.stroke, value: resolveValue(color.stroke.value, variables) } : null
          }
        }
      };
    }
    if (isImageElement(element)) {
      const content = element.data.content;
      if (content && !content.startsWith("http") && !content.startsWith("data:")) {
        const resolvedContent = resolveValue(content, variables);
        const isBrandLogo = isBrandLogoVariable(content) && !!resolvedContent;
        return {
          ...element,
          data: {
            ...element.data,
            content: resolvedContent,
            ...isBrandLogo && { isBrandLogo: true }
          }
        };
      }
    }
    if (isSVGElement(element)) {
      const svg = element.data.svg;
      if (svg && (svg.includes("{{var:") || svg.includes("{{"))) {
        return {
          ...element,
          data: {
            ...element.data,
            svg: resolveSvgVariables(svg, variables)
          }
        };
      }
    }
    return element;
  });
}

// src/helpers.ts
import { IMAGE_VARIABLE_MAPPINGS } from "@adflow/types";
function isBackgroundImageElement(element) {
  var _a, _b;
  return ((_a = element.name) == null ? void 0 : _a.startsWith("BACKGROUND_IMAGE")) || ((_b = element.id) == null ? void 0 : _b.startsWith("BACKGROUND_IMAGE"));
}
function findBackgroundImageUrl(imageElements) {
  var _a;
  if (!imageElements)
    return null;
  const bgElement = imageElements.find((el) => isBackgroundImageElement(el));
  return ((_a = bgElement == null ? void 0 : bgElement.data) == null ? void 0 : _a.content) || null;
}
function buildImageVariablesInSvg(document) {
  const images = document.querySelectorAll("image");
  images.forEach((img) => {
    var _a;
    const dataName = img.getAttribute("data-name");
    if (!dataName)
      return;
    const baseName = dataName.replace(/\.(png|jpg|jpeg|svg|gif|webp)$/i, "").toUpperCase();
    const variableName = (_a = Object.entries(IMAGE_VARIABLE_MAPPINGS).find(
      ([key]) => baseName.startsWith(key)
    )) == null ? void 0 : _a[1];
    if (variableName) {
      img.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", `{{var:${variableName}}}`);
    }
  });
}
function createBackgroundElement(width, height, imageUrl) {
  return {
    id: "background",
    name: "BACKGROUND_IMAGE",
    type: "IMAGE",
    position: { x: 0, y: 0, z: 0 },
    size: { width, height },
    sources: [],
    data: { content: imageUrl }
  };
}
function addNewImageElement(elements, newElement, prepend = true) {
  const identifier = newElement.name || newElement.id;
  if (!identifier) {
    return prepend ? [newElement, ...elements] : [...elements, newElement];
  }
  const exists = elements.some((el) => el.name === identifier || el.id === identifier);
  if (exists) {
    return elements;
  }
  return prepend ? [newElement, ...elements] : [...elements, newElement];
}

// src/index.ts
import { IMAGE_VARIABLE_MAPPINGS as IMAGE_VARIABLE_MAPPINGS2 } from "@adflow/types";

// src/build-brand-variables.ts
import { BrandVariable as BrandVariable3 } from "@adflow/types";
import { applyFontVariantAdjustments } from "@adflow/utils";
function buildBrandVariablesMap(brandKit, fonts = []) {
  var _a, _b, _c, _d;
  if (!brandKit)
    return void 0;
  const variables = {};
  variables[BrandVariable3.PRIMARY_COLOR] = brandKit.primaryColor;
  if (brandKit.secondaryColor) {
    variables[BrandVariable3.SECONDARY_COLOR] = brandKit.secondaryColor;
  }
  if (brandKit.logoUrl) {
    variables[BrandVariable3.LOGO] = brandKit.logoUrl;
    variables[BrandVariable3.BRAND_LOGO] = brandKit.logoUrl;
  }
  if ((_b = (_a = brandKit.fonts) == null ? void 0 : _a.primary) == null ? void 0 : _b.fontFamilyId) {
    const primaryFont = fonts.find((f) => {
      var _a2, _b2;
      return f.fontFamilyId === ((_b2 = (_a2 = brandKit.fonts) == null ? void 0 : _a2.primary) == null ? void 0 : _b2.fontFamilyId);
    });
    if (primaryFont) {
      variables[BrandVariable3.PRIMARY_FONT] = primaryFont.fontFamily;
    }
  }
  if ((_d = (_c = brandKit.fonts) == null ? void 0 : _c.secondary) == null ? void 0 : _d.fontFamilyId) {
    const secondaryFont = fonts.find(
      (f) => {
        var _a2, _b2;
        return f.fontFamilyId === ((_b2 = (_a2 = brandKit.fonts) == null ? void 0 : _a2.secondary) == null ? void 0 : _b2.fontFamilyId);
      }
    );
    if (secondaryFont) {
      variables[BrandVariable3.SECONDARY_FONT] = secondaryFont.fontFamily;
    }
  }
  variables["background_text_color"] = "#FFFFFF";
  return Object.keys(variables).length > 0 ? variables : void 0;
}
function resolveElementsWithBrandKit(elements, brandKit, fonts = []) {
  const brandVariables = buildBrandVariablesMap(brandKit, fonts);
  if (!brandVariables) {
    return elements;
  }
  const resolvedElements = resolveElementVariables(elements, brandVariables);
  const primaryFontFamilyName = brandVariables[BrandVariable3.PRIMARY_FONT];
  const secondaryFontFamilyName = brandVariables[BrandVariable3.SECONDARY_FONT];
  if (!primaryFontFamilyName && !secondaryFontFamilyName) {
    return resolvedElements;
  }
  const parsedFonts = fonts.map((f) => ({
    fontFamily: f.fontFamily,
    weight: f.weight,
    style: f.style,
    stretch: f.stretch ?? "normal",
    variant: f.variant,
    src: f.src
  }));
  const { adjustedElements } = applyFontVariantAdjustments(
    resolvedElements,
    parsedFonts,
    primaryFontFamilyName,
    secondaryFontFamilyName
  );
  return adjustedElements;
}
export {
  BRAND_LOGO_POSSIBLE_VALUES,
  IMAGE_VARIABLE_MAPPINGS2 as IMAGE_VARIABLE_MAPPINGS,
  VariableResolver,
  addNewImageElement,
  VARIABLES as brandVariables,
  buildBrandVariablesMap,
  buildImageVariablesInSvg,
  createBackgroundElement,
  findBackgroundImageUrl,
  isBackgroundImageElement,
  isBrandLogoVariable,
  resolveElementVariables,
  resolveElementsWithBrandKit,
  resolveSvgVariables,
  variablesData
};
